import { Alert } from 'avo-ui'
import { GeneralVoting } from 'components/award/voting/create-voting/GeneralVoting'
import { useValidation } from 'hooks/useValidation'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { API_AWARD } from 'services/apiAward'
import { useFetch } from 'services/useFetch'

const INITIAL_STATE = {
    name: null,
    start_date: null,
    end_date: null,
    categories: {},
}

const DEFAULT_TIME = '00:00'

const VALIDATION = {
    name: {
        required: 'Nama voting wajib diisi',
    },
    start_date: {
        required: 'Tanggal mulai voting wajib diisi',
    },
    end_date: {
        required: 'Tanggal akhir voting wajib diisi',
    },
}

export const GeneralVotingContainer = ({ id, data, onSuccessUpdate }) => {
    const navigate = useNavigate()
    const [dataGeneral, setDataGeneral] = useState(INITIAL_STATE)
    const [tempDate, setTmpDate] = useState({
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
    })
    const { fetching: createAward, isLoading } = useFetch(API_AWARD.AWARD_CREATE)
    const { fetching: updateAward, isLoading: isLoadingUpdate } = useFetch({
        ...API_AWARD.AWARD_UPDATE,
        initPathVariable: id,
    })
    const { errorForm, setErrorForm, validateForm } = useValidation({ form: dataGeneral, schema: VALIDATION })

    useEffect(() => {
        if (data) {
            setInitialState()
        }
    }, [data])

    const setInitialState = () => {
        const { start_date, end_date, ...rest } = data
        setDataGeneral({
            ...rest,
            start_date: moment(start_date).format('YYYY-MM-DD HH:mm'),
            end_date: moment(end_date).format('YYYY-MM-DD HH:mm'),
        })
        setTmpDate({
            start_date: moment(start_date).format('YYYY-MM-DD'),
            start_time: moment(start_date).format('HH:mm'),
            end_date: moment(end_date).format('YYYY-MM-DD'),
            end_time: moment(end_date).format('HH:mm'),
        })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        if (name === 'start_date') {
            setTmpDate({ ...tempDate, start_date: value })
            return setDataGeneral({ ...dataGeneral, start_date: `${value} ${tempDate?.start_time || DEFAULT_TIME}` })
        }
        if (name === 'start_time') {
            setTmpDate({ ...tempDate, start_time: value })
            return setDataGeneral({ ...dataGeneral, start_date: `${tempDate?.start_date} ${value}` })
        }
        if (name === 'end_date') {
            setTmpDate({ ...tempDate, end_date: value })
            return setDataGeneral({ ...dataGeneral, end_date: `${value} ${tempDate?.end_time || DEFAULT_TIME}` })
        }
        if (name === 'end_time') {
            setTmpDate({ ...tempDate, end_time: value })
            return setDataGeneral({ ...dataGeneral, end_date: `${tempDate?.end_date} ${value}` })
        }

        setDataGeneral({ ...dataGeneral, [name]: value })
    }

    const onSubmit = async () => {
        await validateForm()
        if (moment(dataGeneral?.start_date).isSameOrAfter(moment(dataGeneral?.end_date))) {
            setErrorForm({
                ...errorForm,
                end_date: 'Tanggal akhir voting tidak boleh sebelum tanggal mulai voting',
            })
            return
        } else if (moment(dataGeneral?.end_date).isSameOrBefore(moment())) {
            setErrorForm({
                ...errorForm,
                end_date: 'Tanggal dan jam akhir voting tidak boleh sebelum tanggal hari ini',
            })
            return
        }

        if (id && moment(data?.start_date).isSameOrBefore(moment())) {
            if (
                moment(data?.start_date).format('YYYY-MM-DD HH:mm') !== dataGeneral?.start_date ||
                data?.name !== dataGeneral?.name
            ) {
                setInitialState()
                return Alert({
                    icon: 'warning',
                    title: 'Warning',
                    message: 'Hanya boleh edit End Date & Time selama award sedang berlangsung',
                })
            }
        }

        const payload = {
            ...dataGeneral,
            start_date: moment(dataGeneral?.start_date).utc().format('YYYY-MM-DD HH:mm'),
            end_date: moment(dataGeneral?.end_date).utc().format('YYYY-MM-DD HH:mm'),
        }

        const fetch = async () => {
            if (id) {
                await updateAward(payload)
                onSuccessUpdate()
            } else {
                const response = await createAward(payload)
                const { award_id } = response?.data || {}
                navigate(`/awards/voting/create?${award_id ? `&id=${award_id}` : ''}`)
            }
        }

        await fetch()
        Alert({
            icon: 'success',
            title: 'Success',
            message: `Award ${id ? 'Updated' : 'Created'}`,
        })
    }

    const props = {
        data: dataGeneral,
        tempDate,
        errorForm,
        onChangeForm,
        onSubmit,
        isLoading: isLoading || isLoadingUpdate,
    }

    return <GeneralVoting {...props} />
}
